// extracted by mini-css-extract-plugin
export default {"todo-list":"styles_todo-list__j-YUj"};